export const win = window;
export const doc = document;
export const { documentElement, body, head } = doc;
